
/**
 * Utility for optimizing image loading
 */

export const preloadImage = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => {
      console.warn(`Failed to preload image: ${src}`);
      resolve(); // Resolve anyway to not block other images
    };
    img.src = src;
  });
};

export const preloadCriticalImages = async (): Promise<void> => {
  const criticalImages = [
    '/lovable-uploads/5ea40fea-4228-4fee-bb9d-755c237e1d14.png', // Updated to new hero background
    '/lovable-uploads/green-leaves-bg.jpg',
    '/lovable-uploads/1.jpg',
  ];

  try {
    // Load the most critical image first (hero background)
    await preloadImage(criticalImages[0]);
    
    // Load the rest in parallel
    await Promise.all(
      criticalImages.slice(1).map(src => preloadImage(src))
    );
  } catch (error) {
    console.error('Error preloading critical images:', error);
  }
};
